

function Footer(){
    return (
        <div className="attribution" hidden>
    Challenge by <a href="https://www.frontendmentor.io?ref=challenge" target="_Blank" rel="noreferrer">Frontend Mentor</a>. 
    Coded by <a href="/" rel="noreferrer">Amit Dhakal</a>.
  </div>
    );
}
 
export default Footer;
